import type {ServerFolder} from 'typings/portaro.be.types';
import type ReportServerService from './report-server.service';

/**
 * @ngdoc controller
 * @name reportsController
 * @module use-cases.report-server
 *
 * @requires Restangular
 *
 * @description
 * Controller
 */
export default class ReportServerController {

    public static getServerFolder(reportServerService: ReportServerService): Promise<ServerFolder> {
        return reportServerService.getServerFolder();
    }

    /*@ngInject*/
    constructor(public serverFolder: ServerFolder) {}

}
